// prop-type is a library for typechecking of props
import PropTypes from "prop-types";
import { useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// NewUser page components
import { useLocation, useParams } from "react-router-dom";
import FormField from "components/FormField";
import SoftEditor from "components/SoftEditor";
import SelectField from "components/SelectField";
import { BALANCE_SHEET_TYPE_ENUM } from "enums/balance-sheet-type";
import DatepickerField from "components/DatepickerField";
import TableDN from "../components/table-dn";

const typeOptions = [
  { value: BALANCE_SHEET_TYPE_ENUM.DN, label: BALANCE_SHEET_TYPE_ENUM.DN },
  {
    value: BALANCE_SHEET_TYPE_ENUM.DNKLT,
    label: BALANCE_SHEET_TYPE_ENUM.DNKLT,
  },
];

function BalanceSheetInfo({ formData, data }) {
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { reportingUnit, address, time, type, unit, total } = formField;
  const {
    reportingUnit: reportingUnitV,
    address: addressV,
    time: timeV,
    type: typeV,
    unit: unitV,
    total: totalV,
  } = values;

  useEffect(() => {
    // Update Form Field Value
    if (!data || !id) return;
    Object.entries(data).map((field) => {
      setFieldValue(field?.[0], field?.[1]);
    });
    setFieldValue("logo", { preview: data.logo });
  }, [id, data]);

  return (
    <SoftBox>
      <SoftBox lineHeight={0}>
        <SoftTypography variant="h5" fontWeight="bold">
          {id ? (containEdit ? "Cập nhật" : "Chi tiết") : "Tạo"} bảng cân đối
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={reportingUnit.type}
              label={reportingUnit.label}
              name={reportingUnit.name}
              value={reportingUnitV}
              placeholder={reportingUnit.placeholder}
              error={errors.reportingUnit && touched.reportingUnit}
              success={reportingUnitV.length > 0 && !errors.reportingUnit}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <DatepickerField
              type={time.type}
              label={time.label}
              name={time.name}
              placeholder={time.placeholder}
              error={errors.time}
              success={timeV?.toString().length > 0 && !errors.time}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={unit.type}
              label={unit.label}
              name={unit.name}
              value={unitV}
              placeholder={unit.placeholder}
              error={errors.unit && touched.unit}
              success={unitV.length > 0 && !errors.unit}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={total.type}
              label={total.label}
              name={total.name}
              value={totalV}
              placeholder={total.placeholder}
              error={errors.total && touched.total}
              success={totalV?.toString().length > 0 && !errors.total}
            />
          </Grid>
          <Grid item xs={12} style={{ paddingTop: "0px" }}>
            <FormField
              type={address.type}
              label={address.label}
              name={address.name}
              value={addressV}
              placeholder={address.placeholder}
              error={errors.address && touched.address}
              success={addressV.length > 0 && !errors.address}
            />
          </Grid>
          <Grid item xs={12} md={6} style={{ paddingTop: "0px" }}>
            <SelectField
              options={typeOptions}
              type={type.type}
              label={type.label}
              name={type.name}
              value={typeV}
              placeholder={type.placeholder}
              error={errors.type && touched.type}
              success={typeV.length > 0 && !errors.type}
            />
          </Grid>
        </Grid>
      </SoftBox>
      <TableDN />
    </SoftBox>
  );
}

// typechecking props for BalanceSheetInfo
BalanceSheetInfo.propTypes = {
  data: PropTypes.any,
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default BalanceSheetInfo;
